module.exports = {
    "index": {
        "login": "Xếp hạng thành viên",
        "regist": "Quà tặng cho người dùng mới",
        "user": "đội mới",
        "jiang": "thành viên",
        "set": "Nhận xét",
        "lingqyu": "Không có nhận xét nào được nhập , vui lòng đặt",
        "liji": "chưa được nhập , vui lòng đặt nó",
        "list": {
            "0": "Thời gian gửi tiền",
            "1": "Thông tin thẻ ghi nợ",
            "2": "Lưu ý : Nạp tiền vào ví Bitcoin và ví USDT. Miễn phí 10% số tiền gốc nạp + 20 USD phí xử lý",
            "3": "Tôi xin lỗi tôi đã không nhận được nó , vui lòng tiếp tục mua nó",
            "4": "đô la",
            "5": "Số lượng đặt hàng trong ngày đầu tiên đã lên tới 20 và không thể đặt thêm đơn hàng nào nữa.",
            "6": "Xác nhận ngay bây giờ"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "tài khoản ngân hàng",
                "1": "Hủy đơn đặt hàng"
            },
            "tianjia": {
                "0": "Địa chỉ",
                "1": "Chưa nhập địa chỉ , vui lòng đặt địa chỉ"
            },
            "tiqu": {
                "0": "vui lòng nhập",
                "1": "Số dư tài khoản dưới 200, vui lòng nạp tiền trước khi nhận lệnh"
            }
        },
        "guanyu": {
            "title1": "Vui lòng kiểm tra số dư tài khoản",
            "text1": "Số dư tài khoản khả dụng không đủ",
            "title2": "Đơn hàng đã được xử lý , vui lòng làm mới trang",
            "text2": "Lỗi tham số , vui lòng xác nhận số đơn hàng"
        },
        "title_content": {
            "0": "Số đơn hàng không tồn tại",
            "1": "Không thể nhận đơn đặt hàng . Không có đủ hàng trong phạm vi giá của danh mục này.",
            "2": "Lấy đơn hàng không thành công ! Vui lòng thử lại sau!"
        },
        "content": {
            "0": "Nhận đơn hàng thành công",
            "1": "của đơn hàng không đủ, vui lòng đặt hàng lại.",
            "2": "nắm lấy nó"
        },
        "dugengduo": "Số dư cấp độ thành viên không đủ",
        "darkgrey": {
            "1": {
                "title": "Việc lấy đơn hàng đã bị chấm dứt",
                "text": "Giờ nhận phòng"
            },
            "2": {
                "title": "lấy phong bì màu đỏ",
                "text": "Đi để nạp tiền"
            },
            "3": {
                "title": "Nhìn lại",
                "text": "Số dư tài khoản cần phải lớn hơn 200 để mở khóa"
            },
            "4": {
                "title": "Bước tiếp theo",
                "text": "Mã xác nhận"
            },
            "5": {
                "title": "vui lòng nhập mã xác nhận",
                "text": "Xác minh mã xác minh đồ họa không thành công , vui lòng nhập lại"
            },
            "6": {
                "title": "Yêu cầu thành công",
                "text": "Định dạng số điện thoại di động không chính xác"
            }
        },
        "into": {
            "yibiaoban": "Tài khoản không tồn tại",
            "nihao": "người dùng không tồn tại",
            "yue": "Người dùng bị vô hiệu hóa",
            "shebeigong": "Tài khoản này đã được đăng nhập ở nơi khác",
            "riqi": "Vui lòng nhập sai mật khẩu quá nhiều lần liên tiếp.",
            "gaishu": "Hãy thử lại sau vài phút",
            "kaicaizong": "sai mật khẩu",
            "xiaoshili": "đăng nhập thành công",
            "rili": "Mã xác minh không tồn tại",
            "zhouli": "Lỗi mã xác minh",
            "yeli": "Mã xác minh không hợp lệ",
            "tuilian": "Mã mời không tồn tại",
            "hezuo": "Người dùng được đề xuất đã bị vô hiệu hóa",
            "fukuanxin": "Yêu cầu xấu",
            "tianjiadi": "Vui lòng đăng nhập trước",
            "gengxin": "Tài khoản này đã bị vô hiệu hóa",
            "yibiaoti": "Chức năng giao dịch của tài khoản này đã bị đóng băng",
            "yaoqing": "Tài khoản này có đơn hàng chưa hoàn thành và không thể tiếp tục nhận đơn hàng.",
            "yaoqingren": "Số dư ít hơn",
            "shijian": "Không thể tiếp tục giao dịch",
            "choujiangci": "Không đủ số lượng giao dịch cho cấp độ thành viên",
            "choujianggai": "kho báu lãi suất",
            "tuijianren": "Rút tiền sớm trước khi hết hạn , không có lợi nhuận, phí xử lý là",
            "xiejie": "Số tiền đầu tư tối thiểu cho sản phẩm này",
            "jiriqi": "Số tiền đầu tư tối đa cho sản phẩm này",
            "dianjifu": "Dữ liệu bất thường",
            "tishi": {
                "1": "Số dư khả dụng không đủ",
                "2": "Hoạt động thành công",
                "3": "Thao tác không thành công ! Vui lòng kiểm tra số dư tài khoản của bạn"
            },
            "chongzhijin": "Bắt đầu đầu tư",
            "chongzhigai": "vận hành",
            "nindeyu": "Chuyển số dư lãi",
            "mianchong": "Lặp lại thao tác",
            "mianchongci": "Chuyển số dư lãi",
            "chongzhili": {
                "title": "Lỗi tham số",
                "jine": "bị cấm từ",
                "shijian": "Thực hiện thao tác hiện tại ngoài khoảng thời gian",
                "zhauntai": "Số lần nạp tiền không thể ít hơn"
            },
            "yijiangli": "Số tiền nạp không thể lớn hơn",
            "yiqizhuan": "Lỗi định dạng hình ảnh",
            "jianglili": "Gửi không thành công , vui lòng thử lại sau",
            "shezhi": "WeChat trả tiền",
            "mimashe": "Thanh toán bằng Ali Pay",
            "dangqianmishu": "Rút tiền mặt WeChat",
            "xinmi": "Rút tiền mặt Alipay",
            "shuxinmi": "Chưa có thông tin thẻ ngân hàng nào được thêm vào",
            "quemi": "Chưa đặt mật khẩu giao dịch",
            "shuquemi": "Giới hạn rút tiền cấp thành viên là",
            "dainyou": "Việc rút cấp độ hiện tại cần phải được hoàn thành",
            "dianyoudi": "mệnh lệnh",
            "shudainyou": "Thiếu cân bằng",
            "fukuanshe": "Số lần rút tiền cho cấp thành viên ngày hôm nay là không đủ.",
            "bitedi": "Tên chủ tài khoản là bắt buộc",
            "shugukuan": "Độ dài tối đa của tên chủ tài khoản là 30 ký tự.",
            "jisheng": "Tên ngân hàng là bắt buộc",
            "qiangou": "Cần có số thẻ ngân hàng",
            "xiacixiaoshi": "Số điện thoại di động là bắt buộc",
            "yingjian": "Số thẻ ngân hàng đã tồn tại",
            "zonggong": "lỗi hệ thống",
            "maidian": "Trang không tồn tại",
            "yingjiancheng": "Nhận giảm giá",
            "zhuanzhang": "Người dùng chưa đăng nhập",
            "dianfeizong": "Vui lòng không gửi lại",
            "zhuanzhangti": "đạt được thành công",
            "zhaunzhangfeiyong": "thất bại",
            "zuidifei": "thành công",
            "tikuanjin": "Tên và thẻ ngân hàng này đã được liên kết với một tài khoản khác",
            "zuidixian": "Không thể xóa địa chỉ giao hàng mặc định",
            "bijieshou": "Mật khẩu đăng nhập sai",
            "quezhi": "Đã đăng nhập hôm nay",
            "querenti": "Đăng nhập thành công và nhận phong bì màu đỏ",
            "yiwen": "Đăng nhập thành công",
            "tili": "Tất cả các lệnh rút tiền của bạn",
            "yaohaoyou": "Xác minh đã được thông qua",
            "yaohuoci": "Vui lòng đăng nhập để lấy đơn hàng",
            "yihanwei": "Lấy đơn hàng không thành công , vui lòng thử lại sau",
            "gongxihuo": "Lấy đơn hàng không thành công , sản phẩm không đủ trong kho"
        },
        "taocan": {
            "title": "Số điện thoại di động đã được đăng ký",
            "text": "Chỉ có thể gửi một tin nhắn văn bản trong vòng 1 phút",
            "kuanggong": "Gửi thành công",
            "liliang": "Gửi thất bại",
            "jiage": "Tim nhắn đã gửi đi thành công",
            "yingli": "Thông số không đầy đủ"
        },
        "baoming": {
            "title": "Không gian máy chủ không được hỗ trợ . Vui lòng xác nhận rằng nó hỗ trợ tính năng cuộn tròn hoặc fsocket. Hãy liên hệ với nhà cung cấp không gian của bạn để giải quyết vấn đề hoặc thay đổi không gian.",
            "text": "Tài khoản đã hết hạn"
        }
    },
    "login": {
        "yongdeng": "Hạn chế địa chỉ IP",
        "quedeng": "Nội dung chứa từ ngữ nhạy cảm",
        "yonghu": "Thông số sản phẩm bất thường",
        "mima": "Số dư khả dụng không đủ , vui lòng nạp tiền trước",
        "xieyi": "Số tiền hôm nay",
        "tiaokaun": "Số lượng người dùng ngày hôm nay",
        "tongyi": "Số người trực tuyến hôm nay",
        "wangmi": "Năm",
        "zhaomi": "mặt trăng",
        "zhaomiti": "Đăng nhập",
        "feihuiyuan": "tiếp diễn",
        "lizhi": "Đăng nhập hôm nay và nhận được 1 phong bì đỏ",
        "chaunghu": "ngày",
        "yonghumming": "một",
        "mimafu": "hai",
        "zhanghaoyou": "bốn",
        "jinggao": "năm"
    },
    "botton": {
        "lianjie": {
            "0": "sáu",
            "1": "Đã đăng nhập",
            "2": "Đã đăng nhập hôm nay",
            "3": "chuyển ra ngoài"
        },
        "zhichi": {
            "0": "chuyển giao",
            "1": "Trung tâm mua sắm"
        }
    },
    "content": {
        "zhichu": "một",
        "jiage": "hạng hai",
        "yinliang": "Không cho phép",
        "jiaoyizhe": "Thông báo cài đặt",
        "btbjiage": "R",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "Một tài khoản có thể được lấy trong 1 ngày",
        "choujiang": "hoa hồng thế hệ",
        "jiangli": "Cấp độ 1",
        "chongzhi": "Ba thế hệ hoa hồng",
        "zhuanzhang": "Cấp ba",
        "yongjin": "Tải lên ảnh chụp màn hình thanh toán",
        "lijikaishi": "Kéo lên để làm mới",
        "mianfei": "Cấp độ tiếp theo của kênh độc quyền có thể nhận được hoa hồng cao hơn",
        "kaishi": "Kéo xuống để sắp xếp lại",
        "lianjie": "Chiết khấu hoa hồng cấp dưới",
        "zhoumo": "Không thể trống",
        "shizhi": "Dịch vụ khách hàng tận tâm",
        "jiaoyi": "Mật khẩu nhập hai lần không nhất quán",
        "zhichi": "Mật khẩu quỹ được nhập hai lần không nhất quán",
        "fuzhi": "thông tin cá nhân",
        "dangqian": "Để ngăn chặn sự giám sát của nền tảng, chẳng hạn như khớp lệnh",
        "wanshan": "Vui lòng xác nhận mật khẩu giao dịch",
        "buyizhi": "Tin nhắn của người mua",
        "ziyou": "học hỏi",
        "mai": "Hoa hồng thế hệ thứ hai",
        "yaoqing": "Cấp độ 2",
        "yihan": "mã QR",
        "gongxi": "Quản lý mật khẩu giao dịch",
        "huifu": "Chi tiết giao dịch"
    },
    "tanchuang": {
        "one": "Số lượng đơn hàng được thực hiện hôm nay",
        "two": "Đã nhận được hoa hồng ngày hôm nay",
        "title1": "Kết quả hôm nay",
        "title2": "Thu nhập ngày hôm nay"
    },
    "weishangxian": {
        "weishangxian": "Sau khi hoàn thành thao tác trên, vui lòng liên hệ với bộ phận chăm sóc khách hàng để nâng cấp điểm số.",
        "yueshouru": "giá ",
        "meiyuan": "Thêm nhiệm vụ",
        "qianggouzhong": "hội trường truyền giáo",
        "chongzhidizhi": "Giảm giá nhiệm vụ",
        "jine": "phiếu mua hàng",
        "bufu": "Tư cách thành viên có giá trị mãi mãi",
        "zhengque": "cấp độ thành viên",
        "xuanxiang": "Chi tiết thành viên",
        "chongzhi": "Hồ sơ gửi và rút tiền của Yu'e Bao",
        "xiaoshi": "Thu nhập của Yu'e Bao",
        "yongjiu": "chuyển nhượng Yu’e Bao",
        "yongjin": "Yu’e Bao chuyển đi",
        "renshu": "Yu'E Bao",
        "hezuo": "bản cân đối chi thu",
        "fenxiang": "Chuyển số dư",
        "chenggong": "THĂNG BẰNG",
        "tuijianID": "Xin chào , để bảo vệ quyền và lợi ích của bạn, vui lòng ràng buộc chính xác số thẻ và thông tin chi nhánh của bốn ngân hàng lớn (Ngân hàng Trung Quốc, Xây dựng, Công thương, Nông nghiệp nếu bạn điền sai thông tin và tài khoản không được). được nhận, nền tảng này sẽ không chịu bất kỳ trách nhiệm nào! Nền tảng này không hỗ trợ rút tiền mặt từ các ngân hàng ngoài bốn ngân hàng lớn.",
        "neirong": "Hoa hồng cộng thêm",
        "tuijian": "Tỷ lệ hoa hồng"
    },
    "into_one": {
        "yibiaoban": "nhiệm vụ",
        "nihao": "Lưu mã QR vào mã quét cục bộ",
        "yue": "đã lưu thành công",
        "shebeigong": "Lưu ảnh chụp màn hình và quét mã QR để thanh toán",
        "riqi": "Thông báo thông tin",
        "gaishu": "Sửa đổi tên",
        "kaicaizong": "đổi mật khẩu",
        "xiaoshili": "Đã sửa đổi thành công",
        "rili": "Nhân dân tệ",
        "zhouli": "Đang sạc",
        "yeli": "Đang sạc , vui lòng làm mới số dư sau",
        "tuilian": "Nạp tiền và nâng cấp",
        "hezuo": "Trạng thái nạp tiền",
        "fukuanxin": "Nâng cấp để mở khóa",
        "tianjiadi": "Nạp tiền để mở khóa",
        "gengxin": "Lệnh nạp tiền đang chờ thanh toán",
        "yibiaoti": "Kỷ lục nạp tiền",
        "yaoqing": "Hướng dẫn nạp tiền",
        "yaoqingren": "Vui lòng liên hệ bộ phận chăm sóc khách hàng để nạp tiền",
        "shijian": "Số tiền nạp",
        "choujiangci": "nạp tiền",
        "choujianggai": "Nạp tiền .",
        "tuijianren": "đăng ký miễn phí",
        "xiejie": "Chúng tôi đang nỗ lực để giành lấy các đơn đặt hàng và kết quả sẽ được công bố bên dưới.",
        "jiriqi": "tất cả sản phẩm",
        "dianjifu": "Rút tất cả",
        "tishi": {
            "1": "tất cả",
            "2": "Đóng băng",
            "3": "Nếu việc gửi không được xác nhận trong vòng vài phút, hệ thống sẽ đóng băng số tiền đặt hàng."
        },
        "chongzhijin": "điểm",
        "chongzhigai": "xóa bỏ",
        "nindeyu": "Thời gian đến : 5 phút",
        "mianchong": "tài sản sẵn có còn lại",
        "mianchongci": "đang tải",
        "chongzhili": {
            "title": "cập nhật thành công",
            "jine": "Đi tới tải lên",
            "shijian": "Đi nhận đơn đặt hàng",
            "zhauntai": "Đi để thêm"
        },
        "yijiangli": "Gửi mã xác minh",
        "yiqizhuan": "Hủy bỏ",
        "jianglili": "Số dư khả dụng",
        "shezhi": "Số dư khả dụng",
        "mimashe": "hiệp ước",
        "dangqianmishu": "hợp tác",
        "xinmi": "tên",
        "shuxinmi": "Nhập trạng thái thời gian chờ sau",
        "quemi": "hàng hóa",
        "shuquemi": "Trang chủ trung tâm mua sắm",
        "dainyou": "Quay lại trang chủ",
        "dianyoudi": "Kích thước nhóm",
        "shudainyou": "Cân bằng đội",
        "fukuanshe": "Trạng thái hoa hồng nhóm",
        "bitedi": "Tổng hoa hồng của nhóm",
        "shugukuan": "Tổng số tiền nạp lại cho đội",
        "jisheng": "Tổng số đội rút lui",
        "qiangou": "Hoa hồng đặt hàng nhóm",
        "xiacixiaoshi": "Báo cáo nhóm",
        "yingjian": "Luồng nhóm",
        "zonggong": "Quản lý đội",
        "maidian": "đội",
        "yingjiancheng": "Mở trong trình duyệt",
        "zhuanzhang": "Thanh toán trực tuyến",
        "dianfeizong": "khu vực",
        "zhuanzhangti": "Đã sao chép thành công",
        "zhaunzhangfeiyong": "Sao chép đường dẫn",
        "zuidifei": "dòng vô tính",
        "tikuanjin": "bầu trời",
        "zuidixian": "Cài đặt hình đại diện",
        "bijieshou": "hình đại diện",
        "quezhi": "Nếu bạn gặp vấn đề và cần hỗ trợ, vui lòng liên hệ với bộ phận chăm sóc khách hàng trực tuyến",
        "querenti": "Tên",
        "yiwen": "gửi một khoản tiền",
        "tili": "Số tiền gửi không đáp ứng yêu cầu hệ thống",
        "yaohaoyou": "tiền gửi",
        "yaohuoci": "lịch sử truy cập",
        "yihanwei": "bảo lãnh chính thức",
        "gongxihuo": "Chính thức cung cấp"
    },
    "into_two": {
        "yibiaoban": "Quản lý tài chính thường xuyên",
        "nihao": "Chắc chắn",
        "yue": "Kiểm toán thất bại",
        "shebeigong": "kỳ thi đã qua",
        "riqi": "Dịch vụ khách hàng",
        "gaishu": "dịch vụ khách hàng",
        "kaicaizong": "mạng",
        "xiaoshili": "Quản lý mật khẩu",
        "rili": "Kính gửi người dùng, để đảm bảo an toàn cho tiền của bạn, vui lòng liên kết tên thật của bạn và đặt mật khẩu rút tiền. Nếu tên không khớp với tên mở tài khoản thì sẽ không thể rút tiền được",
        "zhouli": "Dấu thập phân phải được điền vào",
        "yeli": "giờ, hệ thống sẽ tự động giải phóng sau khi hết hạn",
        "tuilian": "Vuốt sang trái hoặc phải để xem thêm",
        "hezuo": "Đã được gửi đi",
        "fukuanxin": "hoàn thành",
        "tianjiadi": "Đã thu hồi",
        "gengxin": "Vui lòng nhập email",
        "yibiaoti": "Đã có tài khoản? Đăng nhập",
        "yaoqing": "Đã có tài khoản, tải ngay",
        "yaoqingren": "hết hạn",
        "shijian": "đi qua",
        "choujiangci": "Bị loại bỏ",
        "choujianggai": "Bắt đầu con đường dẫn đến sự giàu có",
        "tuijianren": "Chủ tài khoản",
        "xiejie": "Thỏa thuận mở tài khoản",
        "jiriqi": "Tên tài khoản",
        "dianjifu": "Địa chỉ mở tài khoản",
        "tishi": {
            "1": "Ngân hàng mở tài khoản",
            "2": "Ngân hàng tiền gửi",
            "3": "Thu nhập trong ngày"
        },
        "chongzhijin": "Trong khi chờ thanh toán",
        "chongzhigai": "Chưa giải quyết",
        "nindeyu": "Đang chờ xem xét",
        "mianchong": "Được trả tiền",
        "mianchongci": "Đang chờ nhận",
        "chongzhili": {
            "title": "Để được mở khóa",
            "jine": "Bạn có thể nhấn trực tiếp để xác định mã QR trên WeChat",
            "shijian": "quên mật khẩu",
            "zhauntai": "Rút tiền mặt nhanh chóng"
        },
        "yijiangli": "Tổng số tiền nạp lại",
        "yiqizhuan": "Tổng số tiền rút",
        "jianglili": "Tổng doanh thu",
        "shezhi": "Tổng tài sản",
        "mimashe": "số dư của bạn",
        "dangqianmishu": "Đơn hàng của bạn sẽ được đặt vào",
        "xinmi": "Đơn hàng của bạn đã bị đóng băng , vui lòng kiên nhẫn chờ đợi",
        "shuxinmi": "Đơn đặt hàng của bạn đã hết hạn và không thể xử lý được",
        "quemi": "thông tin nhận dạng của bạn",
        "shuquemi": "Thông tin thẻ ngân hàng của bạn",
        "dainyou": "Bạn có chắc chắn muốn xóa địa chỉ này?",
        "dianyoudi": "Bạn chưa thêm thông tin thẻ ngân hàng",
        "shudainyou": "Tôi đã đồng ý với \"Thỏa thuận dịch vụ\"",
        "fukuanshe": "Tôi đã hoàn tất thanh toán",
        "bitedi": "Tôi đã hiểu và đồng ý",
        "shugukuan": "số dư của tôi",
        "jisheng": "đội của tôi",
        "qiangou": "tổng tài sản của tôi",
        "xiacixiaoshi": "số điện thoại di động của tôi",
        "yingjian": "Đơn hàng của tôi",
        "zonggong": "Túi của tôi",
        "maidian": "Thẻ ghi nợ của tôi",
        "yingjiancheng": "của tôi",
        "zhuanzhang": "Ảnh chụp màn hình hoặc trực tiếp",
        "dianfeizong": "Ngân hàng",
        "zhuanzhangti": "Tất cả hàng hóa",
        "zhaunzhangfeiyong": "các loại",
        "zuidifei": "Số điện thoại di động bị sai",
        "tikuanjin": "Số điện thoại di động nhập sai",
        "zuidixian": "số điện thoại",
        "bijieshou": "Số điện thoại",
        "quezhi": "điện thoại di động",
        "querenti": "phí xử lý",
        "yiwen": "Lấy một đơn đặt hàng",
        "tili": "Thời gian lấy đơn hàng",
        "yaohaoyou": "Số đơn hàng",
        "yaohuoci": "Kỷ lục lấy đơn hàng",
        "yihanwei": "Ghi",
        "gongxihuo": "Hướng dẫn lấy đơn hàng"
    },
    "into_s1": {
        "yibiaoban": "lấy một đơn đặt hàng",
        "nihao": "Số lượng đặt hàng",
        "yue": "Giảm hoa hồng khi nhận đơn đặt hàng",
        "shebeigong": "áp phích quảng cáo",
        "riqi": "Số người được đề xuất",
        "gaishu": "Sản phẩm khuyến cáo",
        "kaicaizong": "gợi ý",
        "xiaoshili": "nộp",
        "rili": "Gửi thành công , vui lòng kiên nhẫn chờ xem xét",
        "zhouli": "Gửi thành công , sẽ sớm được chuyển hướng",
        "yeli": "Nộp đơn đặt hàng",
        "tuilian": "nộp",
        "hezuo": "Số lần rút tiền",
        "fukuanxin": "Trạng thái rút tiền",
        "tianjiadi": "Đơn xin rút tiền đã được gửi",
        "gengxin": "Hồ sơ rút tiền",
        "yibiaoti": "Tỷ lệ rút tiền",
        "yaoqing": "Số tiền rút",
        "yaoqingren": "Giới hạn rút tiền",
        "shijian": "rút",
        "choujiangci": "tìm kiếm",
        "choujianggai": "phương thức thanh toán",
        "tuijianren": "Địa chỉ chi nhánh",
        "xiejie": "người nhận",
        "jiriqi": "Người nhận thanh toán",
        "dianjifu": "tiêu chuẩn thu nhập",
        "tishi": {
            "1": "Loại phúc lợi",
            "2": "Kỷ lục thu nhập",
            "3": "Tên người nhận hàng"
        },
        "chongzhijin": "Thông tin địa chỉ giao hàng",
        "chongzhigai": "Sửa đổi địa chỉ giao hàng",
        "nindeyu": "Chỉnh sửa địa chỉ giao hàng",
        "mianchong": "Địa chỉ giao hàng",
        "mianchongci": "Nhận thông tin nhận dạng",
        "chongzhili": {
            "title": "Người mới",
            "jine": "mật khẩu mới",
            "shijian": "Số điện thoại di động mới",
            "zhauntai": "thời gian"
        },
        "yijiangli": "Hoa hồng của đội ngày hôm qua",
        "yiqizhuan": "Thu nhập của ngày hôm qua",
        "jianglili": "Không có dữ liệu",
        "shezhi": "Chưa có bản ghi nào",
        "mimashe": "Thêm thông tin",
        "dangqianmishu": "Hơn",
        "xinmi": "Thẻ ngân hàng chưa bị ràng buộc , hãy đi ràng buộc",
        "shuxinmi": "Không có khu vực nào được nhập, vui lòng đặt nó",
        "quemi": "Chưa nhập ngân hàng mở tài khoản, vui lòng nhập",
        "shuquemi": "Địa chỉ chi nhánh chưa được nhập, vui lòng nhập địa chỉ đó",
        "dainyou": "Chưa nhập số điện thoại, vui lòng đặt số điện thoại",
        "dianyoudi": "Chưa nhập số điện thoại, vui lòng đặt số điện thoại",
        "shudainyou": "Chưa nhập tên thật, vui lòng đặt tên",
        "fukuanshe": "Chưa nhập địa chỉ chi tiết, vui lòng đặt địa chỉ",
        "bitedi": "Chưa nhập số thẻ ngân hàng, vui lòng nhập số này",
        "shugukuan": "chưa được nhập , vui lòng đặt nó",
        "jisheng": "Dữ liệu này được cung cấp bởi",
        "qiangou": "Phí xử lý sẽ được khấu trừ cho lần rút tiền này.",
        "xiacixiaoshi": "Đang tải",
        "yingjian": "Có thể nhận đơn hàng mỗi ngày",
        "zonggong": "Không có mã QR , vui lòng nhấp vào",
        "maidian": "không có dữ liệu",
        "yingjiancheng": "Không còn nội dung nữa",
        "zhuanzhang": "Không còn dữ liệu",
        "dianfeizong": "Không có hồ sơ",
        "zhuanzhangti": "Thời gian đăng ký",
        "zhaunzhangfeiyong": "đăng ký",
        "zuidifei": "Lưu ý: Do lượng thông tin nạp tiền lớn, hãy nhớ kiểm tra kỹ số thẻ tài khoản trước khi nạp tiền. Nền tảng này thỉnh thoảng thay đổi tài khoản. Nếu bạn có bất kỳ câu hỏi nào, vui lòng nhấp vào dịch vụ khách hàng trực tuyến.",
        "tikuanjin": "Trung tâm hoạt động",
        "zuidixian": "Số người hoạt động",
        "bijieshou": "Địa chỉ giao hàng mới",
        "quezhi": "Lời khuyên tử tế",
        "querenti": "tình trạng",
        "yiwen": "Nạp tiền người dùng",
        "tili": "Tên ngươi dung không được để trông",
        "yaohaoyou": "Lỗi nhập tên người dùng , yêu cầu 2-12 chữ cái hoặc số",
        "yaohuoci": "Người dùng nhận đơn đặt hàng",
        "yihanwei": "Người dùng rút tiền",
        "gongxihuo": "số điện thoại"
    },
    "into_f": {
        "yibiaoban": "Mật khẩu đăng nhập",
        "nihao": "Đăng nhập",
        "yue": "Trực tiếp dưới",
        "shebeigong": "Trực tiếp dưới",
        "riqi": "tên thật",
        "gaishu": "Xác nhận sửa đổi",
        "kaicaizong": "Xác nhận ràng buộc thẻ",
        "xiaoshili": "Chắc chắn",
        "rili": "Xác nhận nạp tiền",
        "zhouli": "Bạn có xác nhận việc hủy bỏ sẽ dẫn đến số tiền bị đóng băng.",
        "yeli": "Xác nhận mật khẩu",
        "tuilian": "Xác nhận rút số tiền này về số dư? Sẽ không tính lãi khi rút tiền quá hạn! , và khấu trừ",
        "hezuo": "Xác nhận để thoát?",
        "fukuanxin": "Quay lại trang của tôi sau vài giây",
        "tianjiadi": "Thứ hai",
        "gengxin": "Rút tiền ngay lập tức",
        "yibiaoti": "Mua ngay",
        "yaoqing": "nâng cấp ngay lập tức",
        "yaoqingren": "Thiết lập ngay bây giờ",
        "shijian": "Đang chờ xác nhận từ người mua",
        "choujiangci": "Đang chờ xác nhận của người mua",
        "choujianggai": "Đang chờ phản hồi của hệ thống người bán",
        "tuijianren": "lọc",
        "xiejie": "Giới thiệu",
        "jiriqi": "thông báo hệ thống",
        "dianjifu": "Hệ thống dựa trên công nghệ LBS và tự động khớp sản phẩm thông qua đám mây.",
        "tishi": {
            "1": "Tài khoản hệ thống",
            "2": "Thu nhập tích lũy",
            "3": "Nạp tiền trực tuyến"
        },
        "chongzhijin": "Nạp tiền ngoại tuyến",
        "chongzhigai": "Ràng buộc số điện thoại di động",
        "nindeyu": "Ràng buộc thẻ ngân hàng",
        "mianchong": "số liệu thống kê",
        "mianchongci": "Chỉnh sửa địa chỉ giao hàng",
        "chongzhili": {
            "title": "Chỉnh sửa thẻ ghi nợ",
            "jine": "biên tập",
            "shijian": "Mạng không ổn định , vui lòng thử lại ở nơi có tín hiệu tốt hơn",
            "zhauntai": "Mạng không ổn định , vui lòng thử lại ở nơi có tín hiệu tốt hơn"
        },
        "yijiangli": "Số liên lạc",
        "yiqizhuan": "Đi nhận đơn đặt hàng",
        "jianglili": "tự động",
        "shezhi": "Tính toán tự động",
        "mimashe": "Trung tâm mua sắm tự vận hành",
        "dangqianmishu": "ĐẾN",
        "xinmi": "Nhận mã xác minh",
        "shuxinmi": "luật lệ",
        "quemi": "Mở khóa",
        "shuquemi": "Số đơn hàng",
        "dainyou": "Đơn hàng đã bị đóng băng và thời gian giải phóng là",
        "dianyoudi": "Đơn hàng đã hết thời gian",
        "shudainyou": "Tổng số lượng đơn đặt hàng",
        "fukuanshe": "Tổng số đơn đặt hàng",
        "bitedi": "Đơn hàng đang được gửi",
        "shugukuan": "Đơn đặt hàng được gửi thành công",
        "jisheng": "chi tiết đặt hàng",
        "qiangou": "Đặt hàng",
        "xiacixiaoshi": "Nhớ mật khẩu",
        "yingjian": "Đặt làm địa chỉ chung",
        "zonggong": "Đặt làm mặc định",
        "maidian": "Đặt hình đại diện",
        "yingjiancheng": "Chi tiết",
        "zhuanzhang": "Địa chỉ",
        "dianfeizong": "Vui lòng tải lên chứng từ thanh toán",
        "zhuanzhangti": "Vui lòng tải lên phiếu nạp tiền",
        "zhaunzhangfeiyong": "Vui lòng kiểm tra kỹ thông tin thanh toán",
        "zuidifei": "Vui long thanh toan",
        "tikuanjin": "Xin vui lòng thay đổi tên của bạn",
        "zuidixian": "Hãy nhớ giữ số tiền chuyển đến số thập phân để tránh ảnh hưởng đến thời gian nạp tiền.",
        "bijieshou": "Vui lòng chuyển khoản và nạp tiền vào tài khoản sau",
        "quezhi": "Vui lòng tham khảo dịch vụ khách hàng trực tuyến sau khi hoàn tất việc nạp tiền",
        "querenti": "Vui lòng điền tên nạp tiền",
        "yiwen": "Vui lòng điền số điện thoại di động nạp tiền",
        "tili": "Vui lòng điền số tiền nạp",
        "yaohaoyou": "Xin vui lòng điền tên của bạn",
        "yaohuoci": "vui lòng điền số điện thoại di động",
        "yihanwei": "Vui lòng điền đúng số điện thoại di động",
        "gongxihuo": "Vui lòng điền địa chỉ chi tiết"
    },
    "into_s": {
        "yibiaoban": "Vui lòng điền địa chỉ giao hàng chi tiết",
        "nihao": "Hãy nhớ mật khẩu của bạn . Nếu bạn quên mật khẩu, vui lòng liên hệ với bộ phận chăm sóc khách hàng.",
        "yue": "Vui lòng hỏi dịch vụ khách hàng trực tuyến (nền tảng thay đổi tài khoản theo thời gian)",
        "shebeigong": "Vui lòng nhập mật khẩu giao dịch",
        "riqi": "Vui lòng nhập số tiền nạp",
        "gaishu": "Vui lòng nhập mật khẩu ban đầu",
        "kaicaizong": "Xin vui lòng nhập mật khẩu",
        "xiaoshili": "Vui lòng nhập tên chủ tài khoản",
        "rili": "Vui lòng nhập số điện thoại di động của chủ tài khoản",
        "zhouli": "Vui lòng nhập địa chỉ ngân hàng mở tài khoản",
        "yeli": "Vui lòng nhập ngân hàng mở tài khoản",
        "tuilian": "Vui lòng nhập ngân hàng nơi mở tài khoản",
        "hezuo": "Vui lòng nhập mật khẩu mới của bạn",
        "fukuanxin": "Vui lòng nhập số điện thoại",
        "tianjiadi": "Vui lòng nhập mã xác minh điện thoại di động",
        "gengxin": "Vui lòng nhập mã giới thiệu",
        "yibiaoti": "Vui lòng nhập số tiền rút",
        "yaoqing": "Vui lòng nhập tên người nhận hàng",
        "yaoqingren": "Vui lòng nhập mật khẩu mới",
        "shijian": "Vui lòng nhập số điện thoại di động hoặc địa chỉ email của bạn",
        "choujiangci": "Vui lòng nhập tên người dùng",
        "choujianggai": "Vui lòng nhập mật khẩu đăng nhập của bạn",
        "tuijianren": "Vui lòng nhập mã xác minh SMS",
        "xiejie": "Vui lòng nhập tài khoản /mật khẩu của bạn",
        "jiriqi": "Vui lòng nhập mật khẩu quỹ",
        "dianjifu": "Vui lòng nhập số tiền chuyển",
        "tishi": {
            "1": "Vui lòng nhập mã mời",
            "2": "Vui lòng nhập số thẻ ngân hàng",
            "3": "vui lòng nhập mã xác nhận"
        },
        "chongzhijin": "Vui lòng chọn kênh thanh toán",
        "chongzhigai": "Vui lòng chọn kênh thanh toán",
        "nindeyu": "Vui lòng chọn địa chỉ giao hàng",
        "mianchong": "Vui lòng chọn cấp độ bạn muốn nâng cấp lên",
        "mianchongci": "số dư tài khoản",
        "chongzhili": {
            "title": "Số tiền bị phong tỏa trong tài khoản",
            "jine": "Chi tiết tài khoản",
            "shijian": "Số tiền tài khoản",
            "zhauntai": "Tiền thu được từ việc mua hàng"
        },
        "yijiangli": "Mua hàng không cần nhập tên thật, vui lòng thiết lập",
        "yiqizhuan": "Khi mua sản phẩm tài chính , lợi nhuận sẽ không được tính cho các giao dịch mua có mục đích xấu và sẽ bị tính phí xử lý.",
        "jianglili": "Mua",
        "shezhi": "Mật khẩu quỹ",
        "mimashe": "Chuyển hướng",
        "dangqianmishu": "Để chuyển tiền, vui lòng sao chép tin nhắn và truy cập ngân hàng trực tuyến hoặc Alipay để hoàn tất việc chuyển tiền và nạp tiền.",
        "xinmi": "Nhập số tiền nạp",
        "shuxinmi": "Nhập tên",
        "quemi": "Nhập số tiền gửi",
        "shuquemi": "nhập số điện thoại di động",
        "dainyou": "Nhập mật khẩu quỹ",
        "dianyoudi": "Trở về",
        "shudainyou": "trở lại",
        "fukuanshe": "Chưa có địa chỉ thu hoạch nào được thêm vào",
        "bitedi": "Chưa thêm thẻ ngân hàng",
        "shugukuan": "Hãy vào cửa hàng và xem thử",
        "jisheng": "Máy chủ từ xa đang phân bổ",
        "qiangou": "đăng xuất",
        "xiacixiaoshi": "Chọn phương thức nạp tiền",
        "yingjian": "Chọn phương thức rút tiền",
        "zonggong": "Chọn số lượng",
        "maidian": "Lựa chọn sản phẩm tài chính",
        "yingjiancheng": "mời bạn bè",
        "zhuanzhang": "Tham gia để nhận được nhiều lợi ích hơn",
        "dianfeizong": "Mã mời",
        "zhuanzhangti": "Liên kết lời mời : bấm vào để sao chép",
        "zhaunzhangfeiyong": "Vui lòng kiểm tra kỹ thông tin thanh toán",
        "zuidifei": "Rút tiền mặt thẻ tài chính",
        "tikuanjin": "Tài khoản thẻ ghi nợ",
        "zuidixian": "Thẻ ngân hàng",
        "bijieshou": "tên ngân hàng",
        "quezhi": "câu hỏi",
        "querenti": "Nếu cần hỗ trợ, bạn có thể liên hệ với bộ phận chăm sóc khách hàng để nạp tiền thủ công.",
        "yiwen": "Cần phải trả lại",
        "tili": "Doanh thu được ước tính",
        "yaohaoyou": "Lợi nhuận kỳ vọng",
        "yaohuoci": "Số người gửi tiền lần đầu",
        "yihanwei": "trang đầu",
        "gongxihuo": "Nạp tiền ngay bây giờ"
    },
    "into_se": {
        "yibiaoban": "Mã xác nhận",
        "nihao": "mặc định",
        "yue": "Vui lòng chụp ảnh màn hình ứng dụng theo cách thủ công và lưu cục bộ để quét mã QR.",
        "shebeigong": "Vui lòng sử dụng APP theo cách thủ công",
        "riqi": "Trang chủ",
        "gaishu": "Mật khẩu đăng nhập",
        "kaicaizong": "Không nộp chưa",
        "xiaoshili": "đăng ký thành công",
        "rili": "Có thể được nâng cấp",
        "zhouli": "Không thể nâng cấp",
        "yeli": "Không thể nâng cấp nếu không đáp ứng các điều kiện nâng cấp",
        "tuilian": "Bạn đã đạt tiêu chí nâng cấp và đã hoàn tất nâng cấp",
        "hezuo": "thông báo hệ thống",
        "fukuanxin": "Số dư người dùng không đủ",
        "tianjiadi": "Không đủ người dùng được mời",
        "gengxin": "Điều kiện nâng cấp không được đáp ứng",
        "yibiaoti": "Số dư tài khoản yêu cầu lớn hơn",
        "yaoqing": "mời",
        "yaoqingren": "Mở khóa",
        "shijian": "địa chỉ ví",
        "choujiangci": "Quét ví có sẵn để chuyển",
        "choujianggai": "Hoa hồng nhóm ngày hôm nay",
        "tuijianren": "Tải xuống ứng dụng",
        "xiejie": "Tiền thưởng nạp tiền",
        "jiriqi": "Vui lòng nhập địa chỉ TRC20",
        "dianjifu": "Vui lòng nhập địa chỉ ERC20",
        "tishi": {
            "1": "về chúng tôi",
            "2": "đại lý",
            "3": "luật lệ"
        },
        "chongzhijin": "giới thiệu",
        "chongzhigai": "Trình độ chuyên môn",
        "nindeyu": "Bất ngờ khi mở hộp quà",
        "mianchong": "Kiếm tiền ngay lập tức",
        "mianchongci": "Mật khẩu cũ",
        "chongzhili": {
            "title": "Vui lòng nhập mật khẩu cũ",
            "jine": "Vui lòng nhập lại mật khẩu",
            "shijian": "mật khẩu đã được cập nhật",
            "zhauntai": "Không thể thay đổi mật khẩu"
        },
        "yijiangli": "Vui lòng đánh dấu vào ô để đồng ý với thỏa thuận",
        "yiqizhuan": "Bạn đã đạt tiêu chí nâng cấp và được tự động nâng cấp",
        "jianglili": "Bị hạ cấp do thay đổi số dư",
        "shezhi": "thông báo hệ thống",
        "mimashe": "lệnh giao dịch",
        "dangqianmishu": "Việc thanh toán đã bị hệ thống ép buộc. Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ với bộ phận chăm sóc khách hàng.",
        "xinmi": "Bật tự động lấy đơn hàng",
        "shuxinmi": "Tắt tự động lấy đơn hàng",
        "quemi": "tên người dùng trùng lặp",
        "shuquemi": "Bị hạ cấp do thay đổi số dư",
        "dainyou": "Bạn đã đạt tiêu chí nâng cấp và được tự động nâng cấp",
        "dianyoudi": "Điện thoại",
        "shudainyou": "về chúng tôi",
        "fukuanshe": "Xem ngay bây giờ",
        "bitedi": "nền tảng",
        "shugukuan": "thông báo",
        "jisheng": "Mời bạn bè để kiếm tiền",
        "chongxindenglu": "Xin vui lòng đăng nhập lại",
        "pingtaijianjie": "Giới thiệu nền tảng",
        "pingtaijianjie1": "Quy tắc lấy lệnh",
        "pingtaijianjie2": "Hợp tác đại lý",
        "pingtaijianjie3": "Trình độ công ty"
    },
    "qing_sd": "Vui lòng chờ",
    "loading1": "proxy trực tuyến",
    "loading2": "yêu cầu đặt hàng",
    "loading3": "Lấy một đơn đặt hàng",
    "goods": {
        "0": "kính xanh",
        "1": "Sản phẩm chăm sóc da độc quyền",
        "2": "Cốc nhựa cấp thực phẩm",
        "3": "nước hoa cổ điển",
        "4": "hạt cà phê nhập khẩu",
        "5": "gấu phong cách Disney"
    },
    "tab_name": {
        "0": "trang đầu",
        "1": "Hồ sơ đặt hàng",
        "2": "Đặt hàng",
        "3": "dịch vụ khách hàng",
        "4": "của tôi"
    },
    "pingjia": "đánh giá",
    "login_t1": "Cửa hàng tổng hợp để mua sắm trên toàn thế giới và nhận giảm giá",
    "zhangh": "Vui lòng nhập số điện thoại di động",
    "email": "E-mail",
    "use_app": "Sử dụng ứng dụng",
    "index_t1": "Giảm thêm 30% + Hoàn tiền 10% + Giao hàng miễn phí cho lần mua ứng dụng đầu tiên của bạn Áp dụng.",
    "qianbao": "cái ví",
    "huoqu_yj": "Nhận hoa hồng",
    "zhangh_ye": "Số dư tài khoản",
    "zhangh_je": "số dư tài khoản",
    "huoq_yj": "Nhận hoa hồng",
    "dingd_s": "số lượng đặt hàng",
    "caoz_bz": "bước",
    "caoz_t1": "1. Nhấp vào nút Bắt đầu tác vụ và làm theo lời nhắc để hoàn thành tác vụ.",
    "caoz_t2": "2. Sau khi hoàn thành nhiệm vụ, bạn có thể thanh toán hoa hồng vào số dư",
    "kefu_t1": "Nếu bạn có thắc mắc hoặc cần trợ giúp,",
    "kefu_t2": "Vui lòng liên hệ bộ phận chăm sóc khách hàng trực tuyến để giải quyết cho bạn",
    "kefu_t3": "Dịch vụ khách hàng tận tâm của bạn",
    "changj_wtjd": "Các câu hỏi thường gặp",
    "changj_wt": {
        "0": {
            "name": "Làm thế nào để nạp tiền và những phương thức thanh toán nào có sẵn ?",
            "value": "Hệ thống này được mở cho nhiều quốc gia và các phương thức thanh toán quốc tế mà chúng tôi cung cấp bao gồm: USDT (ERC20). Đồng thời, chúng tôi cũng hỗ trợ tiền tệ quốc gia của các quốc gia khác nhau."
        },
        "1": {
            "name": "Làm thế nào tôi có thể đầu tư và kiếm thu nhập ?",
            "value": "Bạn có thể tham gia giao dịch hàng hóa trong hệ thống và có được thu nhập giao dịch ổn định hàng ngày. Tất cả thu nhập có thể được rút vào thẻ ngân hàng của bạn."
        },
        "2": {
            "name": "Làm thế nào để đăng ký làm thành viên ?",
            "value": "Hệ thống mời được sử dụng để đăng ký thành viên mới. Để đảm bảo thu nhập của thành viên đã đăng ký và tránh việc đăng ký quá mức làm giảm thu nhập, thành viên mới chỉ có thể đăng ký theo lời mời của thành viên hiện tại."
        },
        "3": {
            "name": "Có giới hạn số tiền mua không ?",
            "value": "Có, để tạo cơ hội kiếm lợi nhuận cho nhiều thành viên hơn, mỗi tài khoản trong hệ thống đều có giới hạn mua tối thiểu."
        }
    },
    "yonghu_m": "tên tài khoản",
    "shoukuan_zh": "Những tài khoản có thể nhận được",
    "youxiang": "Thư",
    "zhanghao": "tài khoản",
    "xiugai_mima": "đổi mật khẩu",
    "xuanze_yy": "Chọn một ngôn ngữ",
	queren:'xác nhận',
	bangka:'Vui lòng ràng buộc tài khoản thanh toán',
	xingy_d:'Xin chúc mừng, bạn đã có được một đơn hàng may mắn'
}